type BrandMarkProps = {
  size?: 'sm' | 'md' | 'lg';
  withWordmark?: boolean;
  className?: string;
};

const sizeClassByValue: Record<NonNullable<BrandMarkProps['size']>, string> = {
  sm: 'h-9',
  md: 'h-11',
  lg: 'h-14'
};

export function BrandMark({ size = 'md', withWordmark = false, className = '' }: BrandMarkProps) {
  if (withWordmark) {
    return (
      <img
        src="/logo_circlus_dark.svg"
        alt="Circlus"
        className={`${sizeClassByValue[size]} w-auto ${className}`.trim()}
      />
    );
  }

  return (
    <img
      src="/circlus-favicon-dark.svg"
      alt="Circlus"
      className={`${sizeClassByValue[size]} w-auto ${className}`.trim()}
    />
  );
}
